import * as React from 'react';

import {Chat} from '@common/react/objects/Chat';

import {getAvatar} from '@common/react/components/Utils/Utils';
import {getUserName} from '@common/react/utils/utils';

import {getChatName} from '@common/react/components/Chat/ChatUtils';
import {BaseUserWithAvatar} from '@common/react/objects/BaseUser';
import {
	ChatComponents,
	ChatListComponentsDictionary,
	useChatSettingsProviderContext
} from '@common/react/components/Chat/ChatSettingsProvider';
import { ChatLastMessageTypeDictionary } from '@common/react/components/Chat/LastMessage';

interface ChatItemProps {
	chat: Chat;
	userId: number;
	selectedChatId: number | null;
	onSelect: (chat: Chat) => void;
	getUser?: (chat, userId) => React.ReactNode; 
}

export const getUserPick = (chat, userId): JSX.Element => {
	const users = chat.contacts.filter((user: BaseUserWithAvatar) => user.id !== userId);
	if (users.length === 1) {
		return <div className="chat-list__item-avatar" style={{ backgroundImage: `url(${getAvatar(users[0])})`}} title={getUserName(users[0])}/>;
	} 
	
	return <div className="chat-list__item-avatar-multiple">
		{users.slice(0, 4).map((user: BaseUserWithAvatar) =>
			<div 
				className="chat-list__item-avatar chat-list__item-avatar_min" 
				key={user.id} 
				title={getUserName(user)} 
				style={{ backgroundImage: `url(${getAvatar(user)})`}}
			/>)}
	</div>;
};

export const ChatItem: React.FC<ChatItemProps> = ({chat, userId, selectedChatId, onSelect, getUser = getUserPick}) => {
	const lastMessage = chat.lastMessage;

	const context = useChatSettingsProviderContext();

	if (!context?.state) throw 'need ChatSettingsContext';

	const {state: {typingDelay: delay, otherComponents}} = context;

	const withTyping = otherComponents.includes(ChatComponents.Mentions);

	return <li className={`chat-list__item ${selectedChatId === chat.id ? 'chat-list__item_active' : ''}`} onClick={() => onSelect(chat)}>
		{getUser(chat, userId)}
		<div className="chat-list__item-content">
			<div className="chat-list__item-name">
				{getChatName(chat, userId)}
			</div>
			{
				lastMessage ?  ChatLastMessageTypeDictionary[lastMessage.chatMessageType]({
					message: lastMessage,
					chat,
					userId
				}) : null
			}
			{withTyping && ChatListComponentsDictionary[ChatComponents.Typing]({chat, delay})}
			{chat.unviewedMessagesCount > 0 && <div className="chat-list__item-count">{chat.unviewedMessagesCount}</div>}
		</div>
	</li>;
};
